import { FEEDBACKS_LOADING_END } from "../actions/types";
import { FEEDBACKS_LOADING } from "../actions/types";
import { GET_FEEDBACKS } from "../actions/types";

const initialState = {
  feedbacks: [],
  loading: false,
};

export default function feedbackReducer(state = initialState, action) {
  switch (action.type) {
    case GET_FEEDBACKS:
      return {
        ...state,
        feedbacks: action.feedbacks,
      };
    case FEEDBACKS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case FEEDBACKS_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    default:
      return {
        ...state,
      };
  }
}
